    import { types } from "./segment.actions";
    import { Reducer } from "../../services/reducer.factory";
    
    const initialState = {
      columns: [{
        field: "oid",
        header: "Código",
        columnKey: "oid",
        sortable: "false",
        filter: "false"
      },{
        field: "description",
        header: "Descrição",
        columnKey: "description",
        sortable: "false",
        filter: "false"
      }],
      currentRecord: {oid:"",description:""},
      
    };
    
    const reducer = new Reducer(initialState, types);
    
    export function CRUDSegmentReducer(state, action) {
      state = reducer.execute(state, action);
      return execute(state,action);
    }
    
    function execute(state, action){
        let result = state;
        switch(action.type){
          
          
        }
        return result;
    }
   
    
    
    